import React, { useEffect } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import UserRegister from './Pages/User';
import PageNotFound from './components/not-found';
import { BASEURL_API_WEBSOCKET } from './constants/env';

function App() {
  useEffect(() => {
    const controller = new AbortController();
    const fetchToken = async () => {
      try {
        const res = await fetch(`${BASEURL_API_WEBSOCKET}/bakong/token`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          signal: controller.signal,
        });

        if (!res.ok) {
          const text = await res.text();
          console.error('Failed to fetch token. Response text:', text);
          return;
        }

        const { data } = await res.json() as { data: { token: string } };
        localStorage.setItem('token', data.token);
      } catch (error: any) {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted');
        } else {
          console.error('Fetch error:', error?.message || error);
        }
      }
    };

    fetchToken();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<UserRegister/>} />
        <Route path="*" element={<PageNotFound/>}/>
      </Routes>
    </div>
  );
}

export default App;